import { render, staticRenderFns } from "./GameLoungeIndex.vue?vue&type=template&id=02ced5a8&scoped=true&"
import script from "./GameLoungeIndex.vue?vue&type=script&lang=ts&"
export * from "./GameLoungeIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ced5a8",
  null
  
)

export default component.exports